export default __webpack_public_path__ + "static/media/28-1_insert.a5bbc0aa.svg";